import { GetAuthorsQuery_query_authors_Author } from '../../../__generated__/queries-web';
import { auth } from '../../../utils/auth';

export type AuthorContext = Pick<
  GetAuthorsQuery_query_authors_Author,
  | 'name'
  | 'id'
  | 'brandKey'
  | 'userId'
  | 'googleId'
  | 'avatarUrl'
  | 'description'
  | 'facebookId'
  | 'twitterId'
  | 'instagramId'
  | 'linkedinId'
  | 'pinterestId'
  | 'snapchatId'
  | 'isMain'
  | 'hasPublicProfile'
  | 'attributes'
  | 'histories'
  | 'resume'
  | 'email'
  | 'media'
  | 'isExternal'
>;

export const initialState = {
  name: '',
  id: '',
  brandKey: null,
  userId: auth.user?.id || null,
  googleId: null,
  avatarUrl: null,
  description: null,
  facebookId: null,
  twitterId: null,
  instagramId: null,
  linkedinId: null,
  pinterestId: null,
  snapchatId: null,
  isMain: false,
  hasPublicProfile: false,
  attributes: [],
  histories: [],
  resume: null,
  email: null,
  media: null,
};
